function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shield_check"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 4c-2.161-.002-6.053-.467-7.293-1.707-.391-.391-1.023-.391-1.414 0-1.241 1.24-5.132 1.705-7.293 1.707-.552 0-1 .448-1 1v9c0 4.421 7.751 7.585 8.635 7.931.117.046.241.069.365.069s.248-.023.365-.069c.884-.346 8.635-3.51 8.635-7.931v-9c0-.552-.447-1-1-1zm-1 10c0 2.217-4.146 4.73-6.999 5.921-2.157-.913-7.001-3.472-7.001-5.921v-8.027c1.696-.082 5.028-.409 7-1.699 1.973 1.29 5.304 1.617 7 1.699z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.957 11.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.5 2.5c.195.195.451.293.707.293s.512-.098.707-.293l5-5c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-4.293 4.293z"
})));

var Svg103Shield = function Svg103Shield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg103Shield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/103-shield.22e398d7.svg";
export { ForwardRef as ReactComponent };